import React, { Component } from "react";
import SearchSelect from "../../../../../../components/searchSelect/SearchSelect";
import { InputFactory, dialog } from "nq-component";
import BaseListPage from "../../../../../../base/BaseListPage";
import Presenter from "../Presenter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";

export default class OtherInfoForm extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new Presenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      level: "",
      selectedLevel: "",
      schoolName: "",
      education: "",
      highest: "",
      scholarship: "",
      graduated: "",
    };
  }

  getCollectionName() {
    return "educational_background";
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  handleLevelChange(selectedLevel) {
    console.warn("FFFF: ", selectedLevel);
    this.setState({ selectedLevel });
  }

  onChangeSchoolName(schoolName) {
    this.setState({ schoolName });
  }
  onChangeEducation(education) {
    this.setState({ education });
  }
  onChangeHighest(highest) {
    this.setState({ highest });
  }

  onChangeScholarship(scholarship) {
    this.setState({ scholarship });
  }

  onChangeDateFrom(datefrom) {
    this.setState({ datefrom });
  }
  onChangeDateTo(dateto) {
    this.setState({ dateto });
  }
  onChangeGraduated(graduated) {
    this.setState({ graduated });
  }

  async handleSaveButton() {
    const data = {
      email: this.props.email,
      empID: this.props.empID,
      educationLevel: this.state.selectedLevel,
      educationSchool: this.state.schoolName,
      educationDegree: this.state.education,
      educationHighest: this.state.highest,
      educationHonors: this.state.scholarship,
      educationFrom: this.state.datefrom,
      educationTo: this.state.dateto,
      educationYear: this.state.graduated,
    };
    console.warn("DATAAA: ", data);
    await this.presenter.upsertUseCase.execute("educational_background", data);
    dialog.close();
    this.props.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }
  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const { selectedLevel } = this.state;
    const level = [
      "Elementary",
      "Secondary",
      "Vocational/Trade Course",
      "College",
      "Graduate Studies",
    ];

    return (
      <>
        <div>
          <h4>Add Educational Background</h4>
          <hr />
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.handleSaveButton();
            }}
          >
            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Level <span style={{ color: "red" }}>*</span>
            </label>
            <SearchSelect
              value={selectedLevel}
              required
              onChange={this.handleLevelChange.bind(this)}
              options={level.map((level) => ({
                label: level,
                value: level,
              }))}
            />

            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Name of School <span style={{ color: "red" }}>*</span>
            </label>
            <InputFactory
              type="String"
              required
              field="schoolName"
              onChange={this.onChangeSchoolName.bind(this)}
            />

            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Basic Education/Degree/Course (Write in full)
            </label>
            <InputFactory
              type="String"
              field="education"
              onChange={this.onChangeEducation.bind(this)}
            />

            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Highest Level/Units Earned (if not graduated)
            </label>
            <InputFactory
              type="String"
              field="highes"
              onChange={this.onChangeHighest.bind(this)}
            />
            {/* <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Scholarship/Academic Honors Received
            </label>
            <InputFactory
              type="String"
              field="scholarship"
              onChange={this.onChangeScholarship.bind(this)}
            /> */}

            <div style={{ margin: "1rem 0" }}>
              <h4>Add Educational Background</h4>
            </div>

            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              From
            </label>
            <InputFactory
              type="String"
              field="datefrom"
              onChange={this.onChangeDateFrom.bind(this)}
            />
            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              To
            </label>
            <InputFactory
              type="String"
              field="dateto"
              onChange={this.onChangeDateTo.bind(this)}
            />

            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Year Graduated
            </label>
            <InputFactory
              type="String"
              field="graduated"
              onChange={this.onChangeGraduated.bind(this)}
            />

            <div className="mt-4 mb-4 d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-light fs-sm me-3"
                onClick={() => dialog.close()}
              >
                Cancel
              </button>
              <button
                // onClick={this.handleSaveButton.bind(this)}
                type="submit"
                className="btn btn-primary fs-sm me-3"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </>
    );
  }
}
